module.exports = __webpack_public_path__ + "img/icon_next.6c5d843a.svg";